// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const assertUnreachable = (unreachable: never | void | undefined): never => {
   // eslint-disable-next-line prettier/prettier
   throw new Error('Didn\'t expect to get here');
};
